// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2sA-D","row":"styles_row__1iyIu"};